import React, { Component } from 'react';

class CustomizeUnsupported extends Component<any, any> {
  constructor(props){
    super(props);
  }

  render() {
    return (
      <div>
        Unsupported
      </div>
    )
  }

}

export default CustomizeUnsupported
